import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { AddSearchTerm } from "@tSchaedlerYesco/Services/SearchTermService";
import { CustomApiHandler, CustomHandler, CustomHandlerWithResult } from "@tSchaedlerYesco/Store/CustomHandlerCreator";
import { ReleaseNumber, SearchTerm } from "@tSchaedlerYesco/Types/CustomAPIModels";

type HandlerType = CustomHandler<{ searchTerm: SearchTerm }>;

const DispatchSetSearchTerm: HandlerType = props => {
    props.dispatch({
        type: "Data/SearchTerm/SetSearchTerm",
        searchTerm: props.parameter.searchTerm
    })
}

const SendDataToApi: HandlerType = async props => {
    await AddSearchTerm(props.parameter.searchTerm)
}

export const chain = [DispatchSetSearchTerm, SendDataToApi];

const setSearchTerm = createHandlerChainRunner(chain, "SetSearchTerm");
export default setSearchTerm;
